export const formatNumber = (num) => {
  if (num === null || num === undefined) return "—";
  return new Intl.NumberFormat("nb-NO").format(num);
};

export const formatCurrency = (num) => {
  if (num === null || num === undefined) return "—";
  return `${formatNumber(num)} tusen kr`;
};

// Smart Y-axis formatter that scales based on max value
export const formatYAxis = (value, maxValue) => {
  if (value === null || value === undefined) return "";
  
  // Determine the best scale based on max value
  const nb = (v, d) => Number(v).toLocaleString("nb-NO", { maximumFractionDigits: d });
  if (maxValue >= 1000000) {
    return `${nb(value / 1000000, 1)}M`;
  } else if (maxValue >= 1000) {
    return `${nb(value / 1000, 1)}k`;
  }
  return nb(value, 0);
};

// Get max value from data array for a specific key
export const getMaxValue = (data, keys) => {
  if (!data || data.length === 0) return 0;
  let max = 0;
  data.forEach(d => {
    keys.forEach(key => {
      if (d[key] && d[key] > max) max = d[key];
    });
  });
  return max;
};

// Desimaltal med norsk komma, t.d. dec(9.14, 1) -> "9,1"
export const dec = (value, decimals = 1) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString("nb-NO", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

// Tal med norsk komma og maks n desimalar (utan unødige nullar), t.d. num(0.95) -> "1" / num(2.85, 2) -> "2,85"
export const num = (value, maxDecimals = 1) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "";
  return Number(value).toLocaleString("nb-NO", { maximumFractionDigits: maxDecimals });
};
